import "../../sass/components/_loader.scss";

const onHide = new Event('onHide');
export default class Loader {
    
    constructor() {
    }
    hide(): void {
        document.querySelector('.loader')?.classList.add('hide')
        document.querySelector('.loader')?.dispatchEvent(onHide)
    }
}